import { render } from "./AppointmentHistory.vue?vue&type=template&id=0612270b&scoped=true"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js"

import "./AppointmentHistory.vue?vue&type=style&index=0&id=0612270b&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0612270b"]])

export default __exports__